/* eslint-disable */
// @ts-nocheck
import type * as Types from '@mgp-frontend/shared/cms-graphql/domain/types';

import { gql } from '@apollo/client';
import { MediaAttributesFragmentDoc } from './page';
import { SpaceFragmentDoc } from '../components/generated/space';
import { TabsFragmentDoc } from '../components/generated/tabs';
import { VerticalStepperFragmentDoc } from '../components/generated/verticalStepper';
import { ReviewsFragmentDoc } from '../components/generated/reviews';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductDetailPagesQueryVariables = Types.Exact<{
  productId: Types.Scalars['String']['input'];
  locale: Types.Scalars['I18NLocaleCode']['input'];
}>;


export type ProductDetailPagesQuery = { __typename?: 'Query', productDetailPages?: { __typename?: 'ProductDetailPageEntityResponseCollection', data: Array<{ __typename?: 'ProductDetailPageEntity', id?: string | null, attributes?: { __typename?: 'ProductDetailPage', title: string, description?: string | null, reviewCount: number, productId: string, price?: number | null, rating: number, productImage: Array<{ __typename?: 'ComponentContentBlocksContentMedia', media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string } | null }> } | null } | null>, zoneSetup?: { __typename?: 'ComponentContentBlocksZoneSetup', id: string, background?: Types.Enum_Componentcontentblockszonesetup_Background | null, container: boolean, display?: Types.Enum_Componentcontentblockszonesetup_Display | null, columnsMobile: number, columnsTablet: number, columnsDesktop?: number | null, verticalPadding?: Types.Enum_Componentcontentblockszonesetup_Verticalpadding | null, maxWidth?: Types.Enum_Componentcontentblockszonesetup_Maxwidth | null, alignText?: Types.Enum_Componentcontentblockszonesetup_Aligntext | null, position?: Types.Enum_Componentcontentblockszonesetup_Position | null, newZone: boolean, backgroundImageFull?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string } | null } | null } | null } | null, dynamicZone?: Array<{ __typename: 'ComponentContentBlocksContentMedia', id: string, autoPlay?: boolean | null, muted?: boolean | null, loop?: boolean | null, controls?: boolean | null, imageLink?: string | null, media?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', name: string, caption?: string | null, alternativeText?: string | null, mime: string, url: string } | null }> } | null, setup?: { __typename?: 'ComponentContentBlocksContentBlockSetup', cssClassNames?: string | null } | null } | { __typename: 'ComponentContentBlocksContentText', id: string, text?: string | null, blockCssClassNames?: string | null, setup?: { __typename?: 'ComponentContentBlocksContentBlockSetup', cssClassNames?: string | null } | null, caption?: { __typename?: 'ComponentContentBlocksHeadline', mainTitle: string, titleType: Types.Enum_Componentcontentblocksheadline_Titletype, titleStyleType?: Types.Enum_Componentcontentblocksheadline_Titlestyletype | null, align?: Types.Enum_Componentcontentblocksheadline_Align | null, titleColor?: Types.Enum_Componentcontentblocksheadline_Titlecolor | null, fontWeight?: Types.Enum_Componentcontentblocksheadline_Fontweight | null, titleCssClassNames?: string | null, subtitle?: string | null, subtitleStyleType?: Types.Enum_Componentcontentblocksheadline_Subtitlestyletype | null, subtitleColor?: Types.Enum_Componentcontentblocksheadline_Subtitlecolor | null, subtitlePosition?: Types.Enum_Componentcontentblocksheadline_Subtitleposition | null, verticalSpacing?: Types.Enum_Componentcontentblocksheadline_Verticalpadding | null } | null, buttonLinks?: Array<{ __typename?: 'ComponentContentBlocksButton', id: string, text: string, url?: string | null, target?: Types.Enum_Componentcontentblocksbutton_Target | null, variant: Types.Enum_Componentcontentblocksbutton_Variant, size: Types.Enum_Componentcontentblocksbutton_Size, iconPosition?: Types.Enum_Componentcontentblocksbutton_Iconposition | null, iconFontAwesome?: string | null, cssClassNames?: string | null, uppercase?: boolean | null } | null> | null } | { __typename: 'ComponentContentBlocksReviews', id: string, title?: string | null, reviewsVariant: Types.Enum_Componentcontentblocksreviews_Variant, reviews?: Array<{ __typename?: 'ComponentContentBlocksReviewsReview', id: string, reviewerName?: string | null, reviewerTitle?: string | null, rating?: number | null, reviewText?: string | null, reviewerPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, name: string, url: string, mime: string } | null } | null } | null } | null> | null } | { __typename: 'ComponentContentBlocksSpace', id: string, top?: Types.Enum_Componentcontentblocksspace_Top | null, bottom?: Types.Enum_Componentcontentblocksspace_Bottom | null, dividerColor?: Types.Enum_Componentcontentblocksspace_Dividercolor | null, cssClassNames?: string | null } | { __typename: 'ComponentContentBlocksTabs', Tab?: Array<{ __typename?: 'ComponentContentBlocksTab', title: string, description: string } | null> | null } | { __typename: 'ComponentContentBlocksVerticalStepper', id: string, step: string, finished?: boolean | null, gradient_to: Types.Enum_Componentcontentblocksverticalstepper_Gradient_To, gradient_via?: Types.Enum_Componentcontentblocksverticalstepper_Gradient_Via | null, stepperVariant?: Types.Enum_Componentcontentblocksverticalstepper_Variant | null } | { __typename: 'ComponentContentBlocksZoneSetup', id: string, background?: Types.Enum_Componentcontentblockszonesetup_Background | null, container: boolean, display?: Types.Enum_Componentcontentblockszonesetup_Display | null, columnsMobile: number, columnsTablet: number, columnsDesktop?: number | null, verticalPadding?: Types.Enum_Componentcontentblockszonesetup_Verticalpadding | null, maxWidth?: Types.Enum_Componentcontentblockszonesetup_Maxwidth | null, alignText?: Types.Enum_Componentcontentblockszonesetup_Aligntext | null, position?: Types.Enum_Componentcontentblockszonesetup_Position | null, gapHorizontal?: Types.Enum_Componentcontentblockszonesetup_Gaphorizontal | null, gapVertical?: Types.Enum_Componentcontentblockszonesetup_Gapvertical | null, newZone: boolean, alignItems?: Types.Enum_Componentcontentblockszonesetup_Alignitems | null, backgroundImageFull?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', name: string, caption?: string | null, alternativeText?: string | null, mime: string, url: string } | null } | null } | null } | { __typename: 'Error' } | null> | null } | null }> } | null };


export const ProductDetailPagesDocument = gql`
    query productDetailPages($productId: String!, $locale: I18NLocaleCode!) {
  productDetailPages(locale: $locale, filters: {productId: {eq: $productId}}) {
    data {
      id
      attributes {
        title
        description
        reviewCount
        productImage {
          media {
            data {
              attributes {
                alternativeText
                caption
                name
                url
                mime
              }
            }
          }
        }
        productId
        price
        rating
        zoneSetup {
          id
          background
          container
          display
          columnsMobile
          columnsTablet
          columnsDesktop
          verticalPadding
          maxWidth
          alignText
          position
          newZone
          backgroundImageFull {
            ...MediaAttributes
          }
        }
        dynamicZone {
          __typename
          ... on ComponentContentBlocksZoneSetup {
            id
            background
            container
            display
            columnsMobile
            columnsTablet
            columnsDesktop
            verticalPadding
            maxWidth
            alignText
            position
            gapHorizontal
            gapVertical
            newZone
            alignItems
            backgroundImageFull {
              data {
                attributes {
                  name
                  caption
                  alternativeText
                  mime
                  url
                }
              }
            }
          }
          ... on ComponentContentBlocksContentText {
            id
            text
            setup {
              cssClassNames
            }
            caption {
              mainTitle
              titleType
              titleStyleType
              align
              titleColor
              fontWeight
              titleCssClassNames
              subtitle
              subtitleStyleType
              subtitleColor
              subtitlePosition
              verticalSpacing: verticalPadding
            }
            buttonLinks {
              id
              text
              url
              target
              variant
              size
              iconPosition
              iconFontAwesome
              cssClassNames
              uppercase
            }
            blockCssClassNames
          }
          ... on ComponentContentBlocksContentMedia {
            id
            media {
              data {
                attributes {
                  name
                  caption
                  alternativeText
                  mime
                  url
                }
              }
            }
            autoPlay
            muted
            loop
            controls
            imageLink
            setup {
              cssClassNames
            }
          }
          ...Space
          ...Tabs
          ...VerticalStepper
          ...Reviews
        }
      }
    }
  }
}
    ${MediaAttributesFragmentDoc}
${SpaceFragmentDoc}
${TabsFragmentDoc}
${VerticalStepperFragmentDoc}
${ReviewsFragmentDoc}`;

/**
 * __useProductDetailPagesQuery__
 *
 * To run a query within a React component, call `useProductDetailPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetailPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetailPagesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useProductDetailPagesQuery(baseOptions: Apollo.QueryHookOptions<ProductDetailPagesQuery, ProductDetailPagesQueryVariables> & ({ variables: ProductDetailPagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductDetailPagesQuery, ProductDetailPagesQueryVariables>(ProductDetailPagesDocument, options);
      }
export function useProductDetailPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductDetailPagesQuery, ProductDetailPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductDetailPagesQuery, ProductDetailPagesQueryVariables>(ProductDetailPagesDocument, options);
        }
export function useProductDetailPagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductDetailPagesQuery, ProductDetailPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductDetailPagesQuery, ProductDetailPagesQueryVariables>(ProductDetailPagesDocument, options);
        }
export type ProductDetailPagesQueryHookResult = ReturnType<typeof useProductDetailPagesQuery>;
export type ProductDetailPagesLazyQueryHookResult = ReturnType<typeof useProductDetailPagesLazyQuery>;
export type ProductDetailPagesSuspenseQueryHookResult = ReturnType<typeof useProductDetailPagesSuspenseQuery>;
export type ProductDetailPagesQueryResult = Apollo.QueryResult<ProductDetailPagesQuery, ProductDetailPagesQueryVariables>;